import BreakpointCalculator from './breakpoint-calculator'
import { fromEvent, BehaviorSubject } from 'rxjs'
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators'

export default class BreakpointSubjectRepository {
  constructor (breakpoints) {
    this.subjects = {}
    this._breakpointCalculator = new BreakpointCalculator(breakpoints)
    this._bindUIActions()
  }

  _getOrRegisterSubject (criteria, predicate) {
    console.log('register', criteria)
    const subjectIdentifier = JSON.stringify(criteria)
    const existingSubject = this.subjects[subjectIdentifier]

    if (existingSubject) {
      return existingSubject
    } else {
      const subject = this._currentBreakpoint$.pipe(
        map(predicate),
        distinctUntilChanged()
      )
      this.subjects[subjectIdentifier] = subject
      return subject
    }
  }

  getBreakpointSubject (queryBreakpoint) {
    return this._getOrRegisterSubject(
      ['exact', queryBreakpoint],
      currentBreakpoint => {
        return this._breakpointCalculator.isBreakpoint(
          currentBreakpoint,
          queryBreakpoint
        )
      }
    )
  }

  getBreakpointAnySubject (queryBreakpoints) {
    return this._getOrRegisterSubject(
      ['any', queryBreakpoints],
      currentBreakpoint => {
        return this._breakpointCalculator.isBreakpointAny(
          currentBreakpoint,
          queryBreakpoints
        )
      }
    )
  }

  getBreakpointRangeSubject (queryFromBreakpoint, queryToBreakpoint) {
    return this._getOrRegisterSubject(
      ['range', queryFromBreakpoint, queryToBreakpoint],
      currentBreakpoint => {
        return this._breakpointCalculator.isBreakpointBetween(
          currentBreakpoint,
          queryFromBreakpoint,
          queryToBreakpoint
        )
      }
    )
  }

  getBreakpointUpSubject (queryFromBreakpoint) {
    return this._getOrRegisterSubject(
      ['up', queryFromBreakpoint],
      currentBreakpoint => {
        return this._breakpointCalculator.isBreakpointUp(
          currentBreakpoint,
          queryFromBreakpoint
        )
      }
    )
  }

  getBreakpointDownSubject (queryToBreakpoint) {
    return this._getOrRegisterSubject(
      ['down', queryToBreakpoint],
      currentBreakpoint => {
        return this._breakpointCalculator.isBreakpointDown(
          currentBreakpoint,
          queryToBreakpoint
        )
      }
    )
  }

  _bindUIActions () {
    const screenWidth$ = new BehaviorSubject(window.innerWidth)

    console.log('fromEvent', fromEvent)
    console.log('debounceTime', debounceTime)
    const resizeDebounced$ = fromEvent(window, 'resize').pipe(debounceTime(100))
    resizeDebounced$.subscribe(() => {
      const width = window.innerWidth
      screenWidth$.next(width)
    })

    this._currentBreakpoint$ = screenWidth$.pipe(
      map(width => {
        return this._breakpointCalculator.getBreakpointByWidth(width)
      }),
      distinctUntilChanged()
    )

    this._currentBreakpoint$.subscribe(currentBreakpoint => {
      console.log('currentBreakpoint', currentBreakpoint)
    })
  }
}
